import React, { useState } from "react";
import "./ImageGallery.css";

export type GalleryPhoto = {
    url: string;
    name: string;
    id: string;
};

type BarsDirection = "left" | "right" | "center";

type ImageGalleryProp = {
    height: string;
    width: string;
    photos: GalleryPhoto[];
    barsDirection: BarsDirection;
};

function ImageGallery(props: ImageGalleryProp) {
    const { barsDirection, height: galleryHeight, width: galleryWidth, photos } = props;

    const [activeIndex, setActiveIndex] = useState(0);

    const photo = photos.find((_element, index) => index === activeIndex);

    let barsClassName: string;
    if (barsDirection === "left") {
        barsClassName = "image_gallery__bars-left";
    } else if (barsDirection === "right") {
        barsClassName = "image_gallery__bars-right";
    } else {
        barsClassName = "image_gallery__bars-center";
    }
    const rotateImage = () => {
        if (activeIndex === photos.length - 1) {
            setActiveIndex(0);
        } else {
            setActiveIndex(activeIndex + 1);
        }
    };

    return (
        <div className="image-gallery">
            <div className="image_gallery__photos">
                {photo && (
                    <img
                        key={photo.id}
                        className="image_gallery__photos-img"
                        src={photo.url}
                        alt="photo"
                        width={galleryWidth}
                        height={galleryHeight}
                        onClick={() => {
                            rotateImage();
                        }}
                    />
                )}
            </div>
            <div className={barsClassName}>
                {photos.map((photoEle, index) => (
                    <div
                        key={photoEle.id}
                        className={
                            index === activeIndex
                                ? "image_gallery__bar-active"
                                : "image_gallery__bar"
                        }
                        onClick={() => {
                            setActiveIndex(index);
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

export default ImageGallery;
